<highcharts-chart *ngIf="chartOptions"
                  [Highcharts]="Highcharts"
                  [options]="chartOptions"
                  [callbackFunction]="getCallbackWithContext()"
                  style="display: block;" [style]="{'height': height}">
</highcharts-chart>
